module.exports = __webpack_public_path__ + "static/lileaLab-20545f74238e655e2073480ff1c89e75.jpg";